export default {
    "活动策划": { "cnTitle": "活  动  策  划", "engTitle": "Activity Planning" },
    "商场服务": { "cnTitle": "商  场  服  务", "engTitle": "Store Service" },
    "店招店牌": { "cnTitle": "店  招  店  牌", "engTitle": "Shop Brand" },
    "灯光工程": { "cnTitle": "灯  光  工  程", "engTitle": "Lighting Project" },
    "城市美化": { "cnTitle": "城  市  美  化", "engTitle": "City Beautification" },
    "新技术": { "cnTitle": "新  技  术", "engTitle": "New Technique" },
    "新案例": { "cnTitle": "新  案  例", "engTitle": "New Cases" }
}